import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-web-iclreferencia',
  templateUrl: './dialog-web-iclreferencia.component.html',
  styleUrls: ['./dialog-web-iclreferencia.component.css']
})
export class DialogWebICLReferenciaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
